<template>
    <div v-bind:class="cssClasses">
        <slot name="left_side"></slot>
        <div class="button-filter" @click="openFilter">
            <span class="pp-icon-filter"></span>
            <span class="button-filter-count" v-if="selected_filters.length">{{selected_filters.length}}</span>
        </div>
        <div class="menu-catalog-group-box">
            <a class="menu-catalog-group-item" v-for="(group, index) in groups" :href="'/#' + group.group"  :key="index" @click="event => navigate(event, '#' + group.group)">
                <span class="pp-icon" :class="[group.icon_class_no_circle]"></span> {{ group.title.toLowerCase() }}
            </a>
        </div>
        <slot name="right_side"></slot>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Utils from "./Utils";
    import {scroller} from 'vue-scrollto/src/scrollTo'
    const scrollerTo = scroller();

    export default {
        name: "CategoryMenu",
        data: function(){
            return {
                defaultClass: 'menu-catalog-group',
                fixedClass: 'fixed',
            }
        },
        computed: {
            ...mapGetters('app', {
                isOpenFilter: 'isOpenFilter',
            }),
            ...mapGetters('catalog', {
                groups: 'getGroups',
                selected_filters: 'getSelectedFilters',
                combos: 'getCombos'
            }),
            cssClasses: function () {
                const classes = [this.defaultClass];
                if(this.isFixed){
                    classes.push(this.fixedClass);
                }
                return classes;
            }
        },
        mixins: [Utils],
        methods: {
          navigate(e, navigateTo){
            e.preventDefault();
            this.$router.push(navigateTo);
            scrollerTo(navigateTo);
          }
        },
        props: {
            isFixed: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>

<style scoped lang="scss">
  .menu-catalog-group-item{
    color: #000;
  }
</style>
